export function PlusIcon({ color = "#D4A655" }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
    >
      <rect width='24' height='24' transform='translate(0.666748)' />
      <path
        d='M7.00989 12.0001L18.3236 12.0001M12.6667 17.657L12.6667 6.34326'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  )
}
export function MinusIcon({ color = "#D4A655" }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
    >
      <rect width='24' height='24' transform='translate(0.666748)' />
      <path
        d='M7.00989 12.0001H18.3236'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  )
}

export function EditIcon({ color = '#98A2B3' }) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/edit-2'>
        <g id='edit-2'>
          <path
            id='Vector'
            d='M13.2601 3.60022L5.0501 12.2902C4.7401 12.6202 4.4401 13.2702 4.3801 13.7202L4.0101 16.9602C3.8801 18.1302 4.7201 18.9302 5.8801 18.7302L9.1001 18.1802C9.5501 18.1002 10.1801 17.7702 10.4901 17.4302L18.7001 8.74022C20.1201 7.24022 20.7601 5.53022 18.5501 3.44022C16.3501 1.37022 14.6801 2.10022 13.2601 3.60022Z'
            stroke={color}
            strokeWidth='1.5'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M11.8899 5.0498C12.3199 7.8098 14.5599 9.9198 17.3399 10.1998'
            stroke={color}
            strokeWidth='1.5'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M3 22H21'
            stroke={color}
            strokeWidth='1.5'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export function HotelIcon({ color = '#98A2B3' }) {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='hotel 1' clipPath='url(#clip0_5464_19849)'>
        <g id='g804'>
          <g id='g806'>
            <g id='Clip path group'>
              <g mask='url(#mask0_5464_19849)'>
                <g id='g808'>
                  <path
                    id='path814'
                    d='M2.97925 16.0312H13.0209V3.47916H2.97925V16.0312Z'
                    stroke={color}
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <g id='g816'>
                    <path
                      id='path818'
                      d='M13.0209 1.97275C13.0209 1.70641 12.9152 1.4511 12.7267 1.26282C12.5384 1.07429 12.2831 0.968598 12.0167 0.968598H3.98344C3.71706 0.968598 3.46175 1.07429 3.27347 1.26282C3.08497 1.4511 2.97925 1.70641 2.97925 1.97275V3.479H13.0209V1.97275Z'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <path
                    id='path820'
                    d='M6.99585 16.0312H9.00422V13.0188H6.99585V16.0312Z'
                    stroke={color}
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <g id='g822'>
                    <path
                      id='path824'
                      d='M4.98755 5.48768V5.98975'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <g id='g826'>
                    <path
                      id='path828'
                      d='M6.99585 5.48768V5.98975'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <g id='g830'>
                    <path
                      id='path832'
                      d='M9.00415 5.48768V5.98975'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <g id='g834'>
                    <path
                      id='path836'
                      d='M11.0125 5.48768V5.98975'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <g id='g838'>
                    <path
                      id='path840'
                      d='M4.98755 7.99791V8.5'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <g id='g842'>
                    <path
                      id='path844'
                      d='M6.99585 7.99791V8.5'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <g id='g846'>
                    <path
                      id='path848'
                      d='M9.00415 7.99791V8.5'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <g id='g850'>
                    <path
                      id='path852'
                      d='M11.0125 7.99791V8.5'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <g id='g854'>
                    <path
                      id='path856'
                      d='M4.98755 10.5082V11.0103'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <g id='g858'>
                    <path
                      id='path860'
                      d='M6.99585 10.5082V11.0103'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <g id='g862'>
                    <path
                      id='path864'
                      d='M9.00415 10.5082V11.0103'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <g id='g866'>
                    <path
                      id='path868'
                      d='M11.0125 10.5082V11.0103'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <g id='g870'>
                    <path
                      id='path872'
                      d='M4.98755 13.0189V13.521'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <g id='g874'>
                    <path
                      id='path876'
                      d='M11.0125 13.0189V13.521'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                  <g id='g878'>
                    <path
                      id='path880'
                      d='M0.46875 16.0312H15.5312'
                      stroke={color}
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id='clip0_5464_19849'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(0 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export function CircleArrowRight({ color = '#98A2B3' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_5464_19896)'>
        <path
          d='M7.99992 10.6668L10.6666 8.00016M10.6666 8.00016L7.99992 5.3335M10.6666 8.00016H5.33325M14.6666 8.00016C14.6666 11.6821 11.6818 14.6668 7.99992 14.6668C4.31802 14.6668 1.33325 11.6821 1.33325 8.00016C1.33325 4.31826 4.31802 1.3335 7.99992 1.3335C11.6818 1.3335 14.6666 4.31826 14.6666 8.00016Z'
          stroke={color}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_5464_19896'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function CircleArrowLeft({ color = '#98A2B3' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_5464_19899)'>
        <path
          d='M8.00008 5.33317L5.33341 7.99984M5.33341 7.99984L8.00008 10.6665M5.33341 7.99984L10.6667 7.99984M1.33341 7.99984C1.33341 4.31794 4.31818 1.33317 8.00008 1.33317C11.682 1.33317 14.6667 4.31794 14.6667 7.99984C14.6667 11.6817 11.682 14.6665 8.00008 14.6665C4.31818 14.6665 1.33341 11.6817 1.33341 7.99984Z'
          stroke={color}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_5464_19899'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(16 16) rotate(-180)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export function FlightIcon({ color = '#98A2B3' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='15'
      viewBox='0 0 16 15'
      fill='none'
    >
      <g mask='url(#mask0_5695_1847)'>
        <path
          d='M14.7296 0.770421C14.0523 0.0931165 12.1305 0.916716 10.4372 2.61002L8.03519 5.01205C5.5528 7.49441 3.68747 9.76992 1.64697 12.6266L2.87335 13.853C5.73008 11.8125 8.00559 9.9472 10.488 7.46484L12.89 5.06281C14.5833 3.36951 15.4069 1.44773 14.7296 0.770421Z'
          stroke={color}
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.28687 12.8138L5.93935 14.4663L6.55254 13.8531L5.99324 11.6267'
          stroke={color}
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3.97396 9.5323L1.64688 8.94767L1.03369 9.56089L2.68618 11.2134'
          stroke={color}
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.2959 4.76102L2.15906 1.07694L1.23926 1.99674L6.16293 6.92041'
          stroke={color}
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.57935 9.33707L13.503 14.2607L14.4228 13.3409L10.7387 7.20407'
          stroke={color}
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.75704 3.8374L7.98434 2.6101L6.75796 1.38372L5.22437 2.91731'
          stroke={color}
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.5827 10.2759L14.1163 8.74228L12.8899 7.5159L11.6626 8.74321'
          stroke={color}
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}
export function TransportationIcon({ color = '#98A2B3' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'
    >
      <path
        d='M13 4H4C3.44772 4 3 4.44772 3 5V9C3 9.55228 3.44772 10 4 10H13C13.5523 10 14 9.55228 14 9V5C14 4.44772 13.5523 4 13 4Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13 10H4C3.44772 10 3 10.4477 3 11V13C3 13.5523 3.44772 14 4 14H13C13.5523 14 14 13.5523 14 13V11C14 10.4477 13.5523 10 13 10Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13 4H4C3.73501 3.99926 3.48109 3.89366 3.29371 3.70629C3.10634 3.51891 3.00074 3.26499 3 3C3.00074 2.73501 3.10634 2.48109 3.29371 2.29371C3.48109 2.10634 3.73501 2.00074 4 2H13C13.265 2.00074 13.5189 2.10634 13.7063 2.29371C13.8937 2.48109 13.9993 2.73501 14 3C13.9993 3.26499 13.8937 3.51891 13.7063 3.70629C13.5189 3.89366 13.265 3.99926 13 4ZM5 14V14.6875C5 14.7704 4.96708 14.8499 4.90847 14.9085C4.84987 14.9671 4.77038 15 4.6875 15H3.8125C3.72962 15 3.65013 14.9671 3.59153 14.9085C3.53292 14.8499 3.5 14.7704 3.5 14.6875V14H5ZM13.5 14V14.6875C13.5 14.7704 13.4671 14.8499 13.4085 14.9085C13.3499 14.9671 13.2704 15 13.1875 15H12.3125C12.2296 15 12.1501 14.9671 12.0915 14.9085C12.0329 14.8499 12 14.7704 12 14.6875V14H13.5Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5Z'
        stroke={color}
        strokeLinejoin='round'
      />
      <path
        d='M5 12.5C5.27614 12.5 5.5 12.2761 5.5 12C5.5 11.7239 5.27614 11.5 5 11.5C4.72386 11.5 4.5 11.7239 4.5 12C4.5 12.2761 4.72386 12.5 5 12.5Z'
        stroke={color}
        strokeLinejoin='round'
      />
      <path
        d='M8.5 4V10M3 3V12M14 3V12'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export function SettingIcon({
  color = '#98A2B3',
  width = '20',
  height = '20'
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='settings' clipPath='url(#clip0_5464_20116)'>
        <g id='Icon'>
          <path
            d='M9.99992 12.5002C11.3806 12.5002 12.4999 11.3809 12.4999 10.0002C12.4999 8.61945 11.3806 7.50016 9.99992 7.50016C8.61921 7.50016 7.49992 8.61945 7.49992 10.0002C7.49992 11.3809 8.61921 12.5002 9.99992 12.5002Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M16.1666 12.5002C16.0557 12.7515 16.0226 13.0303 16.0716 13.3007C16.1206 13.571 16.2495 13.8204 16.4416 14.0168L16.4916 14.0668C16.6465 14.2216 16.7695 14.4054 16.8533 14.6078C16.9372 14.8101 16.9804 15.027 16.9804 15.246C16.9804 15.465 16.9372 15.6819 16.8533 15.8842C16.7695 16.0866 16.6465 16.2704 16.4916 16.4252C16.3368 16.5801 16.153 16.7031 15.9507 16.7869C15.7483 16.8708 15.5314 16.914 15.3124 16.914C15.0934 16.914 14.8765 16.8708 14.6742 16.7869C14.4719 16.7031 14.288 16.5801 14.1332 16.4252L14.0833 16.3752C13.8869 16.183 13.6374 16.0542 13.3671 16.0052C13.0967 15.9561 12.8179 15.9892 12.5666 16.1002C12.3201 16.2058 12.1099 16.3812 11.9618 16.6048C11.8138 16.8283 11.7343 17.0903 11.7333 17.3585V17.5002C11.7333 17.9422 11.5577 18.3661 11.2451 18.6787C10.9325 18.9912 10.5086 19.1668 10.0666 19.1668C9.62456 19.1668 9.20063 18.9912 8.88807 18.6787C8.57551 18.3661 8.39992 17.9422 8.39992 17.5002V17.4252C8.39347 17.1493 8.30418 16.8818 8.14368 16.6574C7.98317 16.433 7.75886 16.2621 7.49992 16.1668C7.24857 16.0559 6.96976 16.0228 6.69943 16.0718C6.4291 16.1208 6.17965 16.2497 5.98325 16.4418L5.93325 16.4918C5.77846 16.6468 5.59465 16.7697 5.39232 16.8536C5.18999 16.9375 4.97311 16.9806 4.75408 16.9806C4.53506 16.9806 4.31818 16.9375 4.11585 16.8536C3.91352 16.7697 3.72971 16.6468 3.57492 16.4918C3.41996 16.337 3.29703 16.1532 3.21315 15.9509C3.12928 15.7486 3.08611 15.5317 3.08611 15.3127C3.08611 15.0936 3.12928 14.8768 3.21315 14.6744C3.29703 14.4721 3.41996 14.2883 3.57492 14.1335L3.62492 14.0835C3.81703 13.8871 3.94591 13.6376 3.99492 13.3673C4.04394 13.097 4.01085 12.8182 3.89992 12.5668C3.79428 12.3204 3.61888 12.1101 3.39531 11.9621C3.17173 11.814 2.90974 11.7346 2.64159 11.7335H2.49992C2.05789 11.7335 1.63397 11.5579 1.32141 11.2453C1.00885 10.9328 0.833252 10.5089 0.833252 10.0668C0.833252 9.6248 1.00885 9.20088 1.32141 8.88832C1.63397 8.57576 2.05789 8.40016 2.49992 8.40016H2.57492C2.85075 8.39371 3.11826 8.30443 3.34267 8.14392C3.56708 7.98341 3.73801 7.75911 3.83325 7.50016C3.94418 7.24882 3.97727 6.97 3.92826 6.69967C3.87924 6.42934 3.75037 6.17989 3.55825 5.9835L3.50825 5.9335C3.35329 5.77871 3.23036 5.59489 3.14649 5.39256C3.06261 5.19023 3.01944 4.97335 3.01944 4.75433C3.01944 4.5353 3.06261 4.31843 3.14649 4.1161C3.23036 3.91377 3.35329 3.72995 3.50825 3.57516C3.66304 3.4202 3.84685 3.29727 4.04918 3.2134C4.25151 3.12952 4.46839 3.08635 4.68742 3.08635C4.90644 3.08635 5.12332 3.12952 5.32565 3.2134C5.52798 3.29727 5.7118 3.4202 5.86658 3.57516L5.91658 3.62516C6.11298 3.81728 6.36243 3.94615 6.63276 3.99517C6.90309 4.04418 7.1819 4.01109 7.43325 3.90016H7.49992C7.74639 3.79453 7.9566 3.61913 8.10466 3.39555C8.25272 3.17198 8.33218 2.90998 8.33325 2.64183V2.50016C8.33325 2.05814 8.50885 1.63421 8.82141 1.32165C9.13397 1.00909 9.55789 0.833496 9.99992 0.833496C10.4419 0.833496 10.8659 1.00909 11.1784 1.32165C11.491 1.63421 11.6666 2.05814 11.6666 2.50016V2.57516C11.6677 2.84332 11.7471 3.10531 11.8952 3.32888C12.0432 3.55246 12.2534 3.72786 12.4999 3.8335C12.7513 3.94443 13.0301 3.97752 13.3004 3.9285C13.5707 3.87948 13.8202 3.75061 14.0166 3.5585L14.0666 3.5085C14.2214 3.35354 14.4052 3.2306 14.6075 3.14673C14.8098 3.06286 15.0267 3.01968 15.2458 3.01968C15.4648 3.01968 15.6817 3.06286 15.884 3.14673C16.0863 3.2306 16.2701 3.35354 16.4249 3.5085C16.5799 3.66328 16.7028 3.8471 16.7867 4.04943C16.8706 4.25176 16.9137 4.46864 16.9137 4.68766C16.9137 4.90669 16.8706 5.12357 16.7867 5.3259C16.7028 5.52823 16.5799 5.71204 16.4249 5.86683L16.3749 5.91683C16.1828 6.11323 16.0539 6.36268 16.0049 6.633C15.9559 6.90333 15.989 7.18215 16.0999 7.4335V7.50016C16.2056 7.74664 16.381 7.95684 16.6045 8.10491C16.8281 8.25297 17.0901 8.33243 17.3583 8.3335H17.4999C17.9419 8.3335 18.3659 8.50909 18.6784 8.82165C18.991 9.13421 19.1666 9.55813 19.1666 10.0002C19.1666 10.4422 18.991 10.8661 18.6784 11.1787C18.3659 11.4912 17.9419 11.6668 17.4999 11.6668H17.4249C17.1568 11.6679 16.8948 11.7474 16.6712 11.8954C16.4476 12.0435 16.2722 12.2537 16.1666 12.5002Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_5464_20116'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export function DepartureIcon({ color = '#98A2B3' }) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Frame' clipPath='url(#clip0_5464_19835)'>
        <g id='Group'>
          <path
            id='Vector'
            d='M15.507 13.2568H0.511175C0.380424 13.2568 0.255028 13.3087 0.162572 13.4012C0.0701169 13.4936 0.018176 13.619 0.018176 13.7498C0.018176 13.8805 0.0701169 14.0059 0.162572 14.0984C0.255028 14.1908 0.380424 14.2428 0.511175 14.2428H15.507C15.6377 14.2428 15.7631 14.1908 15.8556 14.0984C15.948 14.0059 16 13.8805 16 13.7498C16 13.619 15.948 13.4936 15.8556 13.4012C15.7631 13.3087 15.6377 13.2568 15.507 13.2568ZM2.82939 8.59076C2.88926 8.66344 2.9687 8.71745 3.0583 8.74641C3.1479 8.77537 3.24393 8.77807 3.33501 8.75417L6.59867 7.89806L6.31963 10.0289C6.31049 10.0985 6.3163 10.1692 6.33669 10.2363C6.35707 10.3035 6.39156 10.3655 6.43784 10.4182C6.48412 10.471 6.54113 10.5132 6.60505 10.5421C6.66897 10.5711 6.73833 10.586 6.80849 10.586C6.85766 10.586 6.90656 10.5786 6.95356 10.5641L8.67801 10.033C8.7859 9.99978 8.87913 9.93055 8.94212 9.83686L11.1065 6.61659L12.9181 5.86624C13.9247 5.44923 14.6886 5.01572 15.1883 4.57774C16.0693 3.8057 16.0321 3.10749 15.8458 2.6578C15.6756 2.24697 15.2607 1.75732 14.2501 1.75732C13.5543 1.75732 12.6313 1.9935 11.5069 2.45929L4.28808 5.4493L2.21064 3.97773C2.14242 3.92939 2.06302 3.89921 1.97992 3.89001C1.89681 3.88081 1.81273 3.8929 1.73559 3.92514L0.302933 4.52364C0.231954 4.5533 0.168901 4.59915 0.118816 4.65754C0.06873 4.71593 0.0330021 4.78522 0.0144894 4.85989C-0.00402325 4.93455 -0.00480704 5.01251 0.0122008 5.08753C0.0292086 5.16255 0.063536 5.23255 0.112438 5.29193L2.82939 8.59076ZM1.86364 4.94026L3.94028 6.41124C4.00831 6.45941 4.08743 6.48955 4.17027 6.49885C4.2531 6.50815 4.33694 6.4963 4.41396 6.46442L11.8841 3.37016C12.8743 2.96005 13.6923 2.74326 14.25 2.74326C14.8139 2.74326 14.9018 2.95525 14.9348 3.03505C14.9689 3.11735 15.0727 3.36792 14.5385 3.8362C14.1257 4.19787 13.4349 4.58491 12.5407 4.95525L10.5916 5.76258C10.502 5.79973 10.4252 5.86252 10.3711 5.94309L8.2211 9.14206L7.39693 9.39586L7.67143 7.29923C7.68196 7.21908 7.67261 7.13757 7.6442 7.06189C7.6158 6.9862 7.56922 6.91866 7.50856 6.86523C7.4479 6.81179 7.37503 6.7741 7.29637 6.75546C7.21771 6.73683 7.13567 6.73783 7.05748 6.75838L3.3899 7.72045L1.29557 5.17756L1.86364 4.94026Z'
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_5464_19835'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export function VisaIcon({ color = '#98A2B3' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='18'
      viewBox='0 0 10 14'
      fill='none'
    >
      <path
        d='M7.95753 13H0.674744V2.52923H7.95753C8.71293 2.52923 9.32531 3.1416 9.32531 3.89698V11.6323C9.32531 12.3876 8.71293 13 7.95753 13Z'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.674744 2.5293L6.37969 1.05166C7.28496 0.78482 8.19415 1.59504 8.07838 2.5293'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.78146 7.20375C7.78146 8.73997 6.53612 9.98535 4.99988 9.98535C3.46366 9.98535 2.21832 8.73997 2.21832 7.20375C2.21832 5.66753 3.46366 4.42217 4.99988 4.42217C6.53612 4.42217 7.78146 5.66753 7.78146 7.20375Z'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.76294 4.44458C3.73047 6.49909 3.72243 7.91603 4.74628 9.9624'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.2485 9.9624C6.27333 7.91262 6.2737 6.49571 5.24213 4.44458'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.30109 7.20361H7.69433'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.32086 11.5039H3.61218'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.10809 11.5039H7.7814'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export function SendIcon({ color = '#98A2B3' }) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/send-2'>
        <g id='send-2'>
          <path
            id='Vector'
            d='M7.40005 6.32015L15.8901 3.49015C19.7001 2.22015 21.7701 4.30015 20.5101 8.11015L17.6801 16.6002C15.7801 22.3102 12.6601 22.3102 10.7601 16.6002L9.92005 14.0802L7.40005 13.2402C1.69005 11.3402 1.69005 8.23015 7.40005 6.32015Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M10.11 13.6501L13.69 10.0601'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}
export function ExportToPdf({ color = '#98A2B3' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M7 21C5.89543 21 5 20.1046 5 19V3H14L19 8V19C19 20.1046 18.1046 21 17 21H7Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13 3V9H19'
        stroke={color}
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
      <path
        d='M9 13H15'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9 17H15'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export function WhatsAppIcon({ color = '#98A2B3' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M12.0377 3.29004C7.09761 3.29004 3.07723 7.16236 3.07548 11.9213C3.07432 13.4432 3.48774 14.9285 4.27161 16.2367L3 20.7094L7.75142 19.5092C9.07309 20.2006 10.5427 20.5612 12.0343 20.5602H12.0377C16.9779 20.5602 20.9983 16.6873 21 11.9283C21.0012 9.62314 20.0698 7.45327 18.3772 5.82223C16.6852 4.19062 14.4352 3.29062 12.0377 3.29004ZM12.0377 19.1022H12.0348C10.6982 19.1022 9.3871 18.7561 8.24323 18.1023L7.97032 17.9467L5.15187 18.6586L5.90439 16.0108L5.72729 15.7397C4.98343 14.6052 4.58745 13.2779 4.58806 11.9213C4.58981 7.96539 7.932 4.74804 12.0406 4.74804C14.0299 4.74862 15.9002 5.49591 17.3071 6.85172C18.714 8.20752 19.488 10.0104 19.4868 11.9277C19.4851 15.8837 16.1441 19.1022 12.0377 19.1022ZM16.1237 13.7283C15.8996 13.6209 14.7987 13.0989 14.5932 13.0263C14.3882 12.9549 14.239 12.9177 14.0897 13.1337C13.9411 13.3497 13.5114 13.8357 13.3814 13.9791C13.2501 14.1231 13.1195 14.1406 12.8954 14.0331C12.6712 13.9251 11.9495 13.6975 11.0948 12.9624C10.4288 12.3911 9.97935 11.685 9.84871 11.4684C9.71806 11.253 9.83477 11.1363 9.94684 11.0289C10.0473 10.9331 10.171 10.7775 10.2825 10.6515C10.3939 10.5255 10.4311 10.4355 10.5066 10.2915C10.5809 10.148 10.5437 10.0215 10.4874 9.91404C10.4311 9.80546 9.984 8.74404 9.79645 8.31262C9.61529 7.89223 9.43064 7.94855 9.29303 7.94159C9.16239 7.93578 9.01374 7.93404 8.86335 7.93404C8.71529 7.93404 8.472 7.98804 8.26645 8.20404C8.06148 8.42004 7.48258 8.94146 7.48258 10.0029C7.48258 11.0649 8.28503 12.0903 8.3971 12.2343C8.50916 12.3777 9.97645 14.5569 12.223 15.4917C12.7572 15.7129 13.1741 15.8459 13.4998 15.9458C14.0363 16.1101 14.5246 16.0863 14.9102 16.0311C15.3399 15.969 16.2352 15.5097 16.421 15.0063C16.608 14.5029 16.608 14.0709 16.5523 13.9809C16.4977 13.8909 16.3479 13.8369 16.1237 13.7283Z'
        fill={color}
      />
    </svg>
  )
}

export function ArrowDownIcon({ color = '#98A2B3' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='11'
      height='6'
      viewBox='0 0 11 6'
      fill='none'
    >
      <path
        d='M1 0.75L5.5 5.25L10 0.75'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export function ClockIcon({ color = '#98A2B3' }) {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        id='Vector'
        d='M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_2'
        d='M15.71 15.1798L12.61 13.3298C12.07 13.0098 11.63 12.2398 11.63 11.6098V7.50977'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function ClockTimeIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M20.75 13.25C20.75 18.08 16.83 22 12 22C7.17 22 3.25 18.08 3.25 13.25C3.25 8.42 7.17 4.5 12 4.5C16.83 4.5 20.75 8.42 20.75 13.25Z'
        stroke='#292D32'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 8V13'
        stroke='#292D32'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9 2H15'
        stroke='#292D32'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export function PlaneIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M22.0946 1.90587C21.0787 0.889918 18.196 2.12532 15.6561 4.66527L12.053 8.26832C8.32944 11.9919 5.53145 15.4051 2.4707 19.6902L4.31027 21.5298C8.59537 18.469 12.0086 15.671 15.7322 11.9475L19.3352 8.34446C21.8751 5.8045 23.1106 2.92183 22.0946 1.90587Z'
        stroke='#050001'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.43066 19.971L8.9094 22.4497L9.82918 21.5299L8.99022 18.1903'
        stroke='#050001'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.96118 15.0487L2.47057 14.1717L1.55078 15.0916L4.02951 17.5703'
        stroke='#050001'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.4443 7.89177L3.23907 2.36565L1.85938 3.74535L9.24489 11.1309'
        stroke='#050001'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.8691 14.7561L20.2546 22.1416L21.6343 20.7619L16.1082 11.5566'
        stroke='#050001'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.1359 6.50635L11.9769 4.66539L10.1373 2.82582L7.83691 5.12621'
        stroke='#050001'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.8743 16.1636L21.1747 13.8632L19.3351 12.0236L17.4941 13.8646'
        stroke='#050001'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export function PortIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M20.4198 12.3702C21.2898 12.7202 21.8297 13.7502 21.6297 14.6602L21.2197 16.5202C20.5097 19.7202 17.9997 22.0002 14.3797 22.0002H9.61974C5.99974 22.0002 3.48974 19.7202 2.77974 16.5202L2.36974 14.6602C2.16974 13.7502 2.70973 12.7202 3.57973 12.3702L4.99974 11.8002L10.5098 9.59018C11.4698 9.21018 12.5297 9.21018 13.4897 9.59018L18.9997 11.8002L20.4198 12.3702Z'
        stroke='#292D32'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 22V10'
        stroke='#292D32'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19 8V11.8L13.49 9.59C12.53 9.21 11.47 9.21 10.51 9.59L5 11.8V8C5 6.35 6.35 5 8 5H16C17.65 5 19 6.35 19 8Z'
        stroke='#292D32'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.5 5H9.5V3C9.5 2.45 9.95 2 10.5 2H13.5C14.05 2 14.5 2.45 14.5 3V5Z'
        stroke='#292D32'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function HotelTimeIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='27'
      height='24'
      viewBox='0 0 27 24'
      fill='none'
    >
      <path
        d='M16.006 17.0532H10.9531V22.9478H16.006V17.0532Z'
        fill='#EBEBEB'
      />
      <path
        d='M22.3214 18.7368V22.9479H20.2158V5.26416H24.4257V17.8951L22.3214 18.7368Z'
        fill='#EBEBEB'
      />
      <path
        d='M2.53228 22.9478H6.74219L6.74219 5.26399H2.53228L2.53228 22.9478Z'
        fill='#EBEBEB'
      />
      <path
        d='M10.1681 9.56577C10.4983 9.56577 10.766 9.29812 10.766 8.96795C10.766 8.63777 10.4983 8.37012 10.1681 8.37012C9.83797 8.37012 9.57031 8.63777 9.57031 8.96795C9.57031 9.29812 9.83797 9.56577 10.1681 9.56577Z'
        fill='#050001'
      />
      <path
        d='M13.7551 9.56577C14.0852 9.56577 14.3529 9.29812 14.3529 8.96795C14.3529 8.63777 14.0852 8.37012 13.7551 8.37012C13.4249 8.37012 13.1572 8.63777 13.1572 8.96795C13.1572 9.29812 13.4249 9.56577 13.7551 9.56577Z'
        fill='#050001'
      />
      <path
        d='M17.342 9.56577C17.6721 9.56577 17.9398 9.29812 17.9398 8.96795C17.9398 8.63777 17.6721 8.37012 17.342 8.37012C17.0118 8.37012 16.7441 8.63777 16.7441 8.96795C16.7441 9.29812 17.0118 9.56577 17.342 9.56577Z'
        fill='#050001'
      />
      <path
        d='M10.1681 7.17466C10.4983 7.17466 10.766 6.907 10.766 6.57683C10.766 6.24666 10.4983 5.979 10.1681 5.979C9.83797 5.979 9.57031 6.24666 9.57031 6.57683C9.57031 6.907 9.83797 7.17466 10.1681 7.17466Z'
        fill='#050001'
      />
      <path
        d='M10.1681 4.78355C10.4983 4.78355 10.766 4.51589 10.766 4.18572C10.766 3.85555 10.4983 3.58789 10.1681 3.58789C9.83797 3.58789 9.57031 3.85555 9.57031 4.18572C9.57031 4.51589 9.83797 4.78355 10.1681 4.78355Z'
        fill='#050001'
      />
      <path
        d='M13.7551 7.17466C14.0852 7.17466 14.3529 6.907 14.3529 6.57683C14.3529 6.24666 14.0852 5.979 13.7551 5.979C13.4249 5.979 13.1572 6.24666 13.1572 6.57683C13.1572 6.907 13.4249 7.17466 13.7551 7.17466Z'
        fill='#050001'
      />
      <path
        d='M13.7551 4.78355C14.0852 4.78355 14.3529 4.51589 14.3529 4.18572C14.3529 3.85555 14.0852 3.58789 13.7551 3.58789C13.4249 3.58789 13.1572 3.85555 13.1572 4.18572C13.1572 4.51589 13.4249 4.78355 13.7551 4.78355Z'
        fill='#050001'
      />
      <path
        d='M17.342 7.17466C17.6721 7.17466 17.9398 6.907 17.9398 6.57683C17.9398 6.24666 17.6721 5.979 17.342 5.979C17.0118 5.979 16.7441 6.24666 16.7441 6.57683C16.7441 6.907 17.0118 7.17466 17.342 7.17466Z'
        fill='#050001'
      />
      <path
        d='M17.342 4.78355C17.6721 4.78355 17.9398 4.51589 17.9398 4.18572C17.9398 3.85555 17.6721 3.58789 17.342 3.58789C17.0118 3.58789 16.7441 3.85555 16.7441 4.18572C16.7441 4.51589 17.0118 4.78355 17.342 4.78355Z'
        fill='#050001'
      />
      <path
        d='M10.1681 11.9574C10.4983 11.9574 10.766 11.6897 10.766 11.3595C10.766 11.0294 10.4983 10.7617 10.1681 10.7617C9.83797 10.7617 9.57031 11.0294 9.57031 11.3595C9.57031 11.6897 9.83797 11.9574 10.1681 11.9574Z'
        fill='#050001'
      />
      <path
        d='M13.7551 11.9574C14.0852 11.9574 14.3529 11.6897 14.3529 11.3595C14.3529 11.0294 14.0852 10.7617 13.7551 10.7617C13.4249 10.7617 13.1572 11.0294 13.1572 11.3595C13.1572 11.6897 13.4249 11.9574 13.7551 11.9574Z'
        fill='#050001'
      />
      <path
        d='M17.342 11.9574C17.6721 11.9574 17.9398 11.6897 17.9398 11.3595C17.9398 11.0294 17.6721 10.7617 17.342 10.7617C17.0118 10.7617 16.7441 11.0294 16.7441 11.3595C16.7441 11.6897 17.0118 11.9574 17.342 11.9574Z'
        fill='#050001'
      />
      <path
        d='M26.1101 22.3153H23.1629V19.7088C24.0296 19.55 24.8329 19.1468 25.4782 18.5467C26.1234 17.9467 26.5838 17.1747 26.805 16.3218C27.0263 15.4689 26.9992 14.5705 26.7269 13.7324C26.4547 12.8944 25.9487 12.1516 25.2684 11.5915V6.31624C25.4918 6.31624 25.7061 6.22749 25.864 6.06952C26.022 5.91155 26.1107 5.6973 26.1107 5.4739C26.1107 5.2505 26.022 5.03624 25.864 4.87827C25.7061 4.7203 25.4918 4.63156 25.2684 4.63156H21.0573V1.65557C21.2626 1.61185 21.444 1.49258 21.5655 1.3214C21.687 1.15021 21.7398 0.93962 21.7133 0.731376C21.6868 0.523133 21.583 0.332444 21.4225 0.197119C21.2621 0.0617949 21.0566 -0.00828272 20.8469 0.000781181H6.1104C5.90068 -0.00828272 5.6952 0.0617949 5.53472 0.197119C5.37424 0.332444 5.27047 0.523133 5.24399 0.731376C5.21751 0.93962 5.27025 1.15021 5.39175 1.3214C5.51325 1.49258 5.69465 1.61185 5.89997 1.65557V4.63275H1.69006C1.46666 4.63275 1.25241 4.7215 1.09444 4.87947C0.936467 5.03744 0.84772 5.25169 0.84772 5.47509C0.84772 5.6985 0.936467 5.91275 1.09444 6.07072C1.25241 6.22869 1.46666 6.31743 1.69006 6.31743V22.3153H0.84234C0.618938 22.3153 0.404685 22.4041 0.246716 22.562C0.0887463 22.72 0 22.9343 0 23.1577C0 23.3811 0.0887463 23.5953 0.246716 23.7533C0.404685 23.9113 0.618938 24 0.84234 24H26.1101C26.3336 24 26.5478 23.9113 26.7058 23.7533C26.8637 23.5953 26.9525 23.3811 26.9525 23.1577C26.9525 22.9343 26.8637 22.72 26.7058 22.562C26.5478 22.4041 26.3336 22.3153 26.1101 22.3153ZM5.90355 22.3153H3.37354V6.31624H5.89997L5.90355 22.3153ZM15.1663 22.3153H11.7946V18.1054H15.1627L15.1663 22.3153ZM21.4818 22.3153H16.8474V17.2637C16.8474 17.0417 16.7592 16.8288 16.6023 16.6719C16.4453 16.5149 16.2324 16.4267 16.0104 16.4267H10.9528C10.7308 16.4267 10.518 16.5149 10.361 16.6719C10.204 16.8288 10.1159 17.0417 10.1159 17.2637V22.3165H7.58465V1.68546H19.375V9.26473C19.375 9.48813 19.4638 9.70238 19.6217 9.86035C19.7797 10.0183 19.994 10.1071 20.2174 10.1071C20.4408 10.1071 20.655 10.0183 20.813 9.86035C20.971 9.70238 21.0597 9.48813 21.0597 9.26473V6.31624H23.5837V10.7067C22.9813 10.5351 22.3503 10.4876 21.7289 10.567C21.1076 10.6464 20.5088 10.8512 19.9689 11.1688C19.429 11.4865 18.9592 11.9104 18.5879 12.4149C18.2167 12.9195 17.9517 13.4941 17.8091 14.1041C17.6664 14.714 17.6491 15.3466 17.7581 15.9634C17.8671 16.5803 18.1002 17.1686 18.4432 17.6927C18.7862 18.2168 19.2321 18.6659 19.7538 19.0126C20.2755 19.3594 20.8621 19.5966 21.4782 19.71L21.4818 22.3153ZM22.3187 16.4207C22.0967 16.4207 21.8839 16.5089 21.7269 16.6659C21.5699 16.8228 21.4818 17.0357 21.4818 17.2577V17.9751C20.8034 17.7728 20.2205 17.333 19.8396 16.7363C19.4588 16.1395 19.3055 15.4256 19.4077 14.7251C19.5099 14.0246 19.8609 13.3843 20.3964 12.9213C20.9319 12.4582 21.6162 12.2034 22.3241 12.2034C23.032 12.2034 23.7163 12.4582 24.2518 12.9213C24.7873 13.3843 25.1383 14.0246 25.2405 14.7251C25.3427 15.4256 25.1894 16.1395 24.8086 16.7363C24.4277 17.333 23.8448 17.7728 23.1664 17.9751V17.2577C23.1664 17.0357 23.0783 16.8228 22.9213 16.6659C22.7643 16.5089 22.5515 16.4207 22.3295 16.4207H22.3187Z'
        fill='#050001'
      />
    </svg>
  )
}

export function BusTimeIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M20.2844 17.2688H23.2969V10.4907C23.2969 7.57908 20.9366 5.21878 18.025 5.21878H2.20936C2.01156 5.21873 1.81569 5.25768 1.63296 5.33341C1.45023 5.40914 1.28423 5.52016 1.14445 5.66011C1.00449 5.79988 0.893469 5.96588 0.817741 6.14861C0.742012 6.33135 0.703063 6.52722 0.703125 6.72502V17.2688H3.71559'
        stroke='#050001'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.97559 10.4915H11.2475V5.21956H5.97559V10.4915Z'
        stroke='#050001'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.97502 5.21956H2.20941C1.37756 5.21956 0.703125 5.894 0.703125 6.7258V10.4915H5.97502V5.21956Z'
        stroke='#050001'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.2471 10.4915H16.519V5.21956H11.2471V10.4915Z'
        stroke='#050001'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M23.2967 10.4938C23.2967 7.58221 20.9364 5.22191 18.0248 5.22191H16.5186V10.4938L23.2967 12.7532V10.4938Z'
        stroke='#050001'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.2221 15.7641C6.05352 15.7641 6.72834 16.4389 6.72834 17.2703C6.72834 18.1018 6.05352 18.7766 5.2221 18.7766C4.39063 18.7766 3.71582 18.1018 3.71582 17.2703C3.71582 16.4389 4.39063 15.7641 5.2221 15.7641Z'
        stroke='#050001'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.7787 15.7641C19.6102 15.7641 20.285 16.4389 20.285 17.2703C20.285 18.1018 19.6102 18.7766 18.7787 18.7766C17.9473 18.7766 17.2725 18.1018 17.2725 17.2703C17.2725 16.4389 17.9473 15.7641 18.7787 15.7641Z'
        stroke='#050001'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.72754 17.2688H17.2713'
        stroke='#050001'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export function MosqueTimeIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <g clipPath='url(#clip0_6931_11029)'>
        <path
          d='M0.703125 16.418H23.2964M0.703125 23.2963H23.2964M21.1402 16.418V12.6148H2.85929V16.418M18.0934 16.418V12.6148M15.0466 16.418V12.6148M11.9998 16.418V12.6148M8.95294 16.418V12.6148M5.90614 16.418V12.6148M19.5 12.6148C19.5 8.49247 16.1582 5.15063 12.0359 5.15063H11.9636C7.84131 5.15063 4.49947 8.49242 4.49947 12.6148M2.22613 16.418H21.8846V23.2963H2.22613V16.418Z'
          stroke='#050001'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.0555 0.703857V2.90776M14.3518 5.51923V5.26367C14.3518 3.96471 13.2988 2.91174 11.9999 2.91174C10.7009 2.91174 9.64795 3.96476 9.64795 5.26367V5.51923M6.39426 18.9287C5.54817 18.9287 4.8623 19.6146 4.8623 20.4607V23.2963H7.92622V20.4607C7.92622 19.6146 7.24031 18.9287 6.39426 18.9287ZM11.9999 18.9287C11.1538 18.9287 10.4679 19.6146 10.4679 20.4607V23.2963H13.5318V20.4607C13.5318 19.6146 12.8459 18.9287 11.9999 18.9287ZM17.6055 18.9287C16.7594 18.9287 16.0735 19.6146 16.0735 20.4607V23.2963H19.1375V20.4607C19.1375 19.6146 18.4515 18.9287 17.6055 18.9287Z'
          stroke='#050001'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_6931_11029'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function SaveIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17 21V13H7V21'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7 3V8H15'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function BankIcon({ color = '#98A2B3' }) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        id='Vector'
        d='M12.37 2.14984L21.37 5.74982C21.72 5.88982 22 6.30981 22 6.67981V9.99982C22 10.5498 21.55 10.9998 21 10.9998H3C2.45 10.9998 2 10.5498 2 9.99982V6.67981C2 6.30981 2.28 5.88982 2.63 5.74982L11.63 2.14984C11.83 2.06984 12.17 2.06984 12.37 2.14984Z'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_2'
        d='M22 22H2V19C2 18.45 2.45 18 3 18H21C21.55 18 22 18.45 22 19V22Z'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_3'
        d='M4 18V11'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_4'
        d='M8 18V11'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_5'
        d='M12 18V11'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_6'
        d='M16 18V11'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_7'
        d='M20 18V11'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_8'
        d='M1 22H23'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_9'
        d='M12 8.5C12.8284 8.5 13.5 7.82843 13.5 7C13.5 6.17157 12.8284 5.5 12 5.5C11.1716 5.5 10.5 6.17157 10.5 7C10.5 7.82843 11.1716 8.5 12 8.5Z'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function CateringIcon({ color = '#98A2B3' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='13'
      viewBox='0 0 12 13'
      fill={color}
    >
      <g clipPath='url(#clip0_8608_27040)'>
        <path
          d='M11.1797 0.5H6.82031C6.36799 0.5 6 0.867992 6 1.32031V6.78905C5.72517 6.70585 5.44238 6.65172 5.15625 6.62755V6.12064H5.41863C5.61279 6.12064 5.7702 5.96323 5.7702 5.76908C5.7702 5.57492 5.61279 5.41752 5.41863 5.41752H4.19072C3.99656 5.41752 3.83916 5.57492 3.83916 5.76908C3.83916 5.96323 3.99656 6.12064 4.19072 6.12064H4.45312V6.62755C2.45585 6.79674 0.859242 8.39335 0.690047 10.3906H0.585938C0.262852 10.3906 0 10.6535 0 10.9766V11.2109C0 11.9217 0.578273 12.5 1.28906 12.5H11.1797C11.632 12.5 12 12.132 12 11.6797V1.32031C12 0.867992 11.632 0.5 11.1797 0.5ZM0.703125 11.2109V11.0938H8.90625V11.2109C8.90625 11.534 8.6434 11.7969 8.32031 11.7969H1.28906C0.965977 11.7969 0.703125 11.534 0.703125 11.2109ZM4.80469 7.31555C6.57548 7.31555 8.03684 8.6657 8.21341 10.3906H1.39596C1.57254 8.6657 3.03389 7.31555 4.80469 7.31555ZM11.2969 11.6797C11.2969 11.7443 11.2443 11.7969 11.1797 11.7969H9.46793C9.56102 11.6156 9.60951 11.4147 9.60938 11.2109V10.9766C9.60938 10.6535 9.34652 10.3906 9.02344 10.3906H8.91933C8.79703 8.94706 7.92914 7.7128 6.70312 7.07544V1.32031C6.70312 1.2557 6.7557 1.20312 6.82031 1.20312H11.1797C11.2443 1.20312 11.2969 1.2557 11.2969 1.32031V11.6797Z'
          fill={color}
        />
        <path
          d='M8.56699 2.9375H9.43417C9.62833 2.9375 9.78574 2.78009 9.78574 2.58594C9.78574 2.39178 9.62833 2.23438 9.43417 2.23438H8.56699C8.37283 2.23438 8.21542 2.39178 8.21542 2.58594C8.21542 2.78009 8.37283 2.9375 8.56699 2.9375ZM10.3248 4.34375H7.67636C7.4822 4.34375 7.3248 4.50116 7.3248 4.69531C7.3248 4.88947 7.4822 5.04688 7.67636 5.04688H10.3248C10.519 5.04688 10.6764 4.88947 10.6764 4.69531C10.6764 4.50116 10.519 4.34375 10.3248 4.34375ZM10.3248 5.75H7.67636C7.4822 5.75 7.3248 5.90741 7.3248 6.10156C7.3248 6.29572 7.4822 6.45312 7.67636 6.45312H10.3248C10.519 6.45312 10.6764 6.29572 10.6764 6.10156C10.6764 5.90741 10.519 5.75 10.3248 5.75ZM4.55174 8.65154C4.56449 8.65154 4.57741 8.65084 4.59037 8.64943C4.66174 8.64166 4.73348 8.63776 4.80527 8.63776C4.99942 8.63776 5.15683 8.48035 5.15683 8.2862C5.15683 8.09204 4.99942 7.93463 4.80527 7.93463C4.70805 7.93463 4.61003 7.93995 4.51396 7.95045C4.32095 7.97155 4.18157 8.14512 4.20269 8.33813C4.22238 8.51818 4.3747 8.65154 4.55174 8.65154ZM2.59771 9.82095C2.64866 9.84835 2.7056 9.86269 2.76344 9.8627C2.88885 9.8627 3.01024 9.79538 3.07361 9.67712C3.24278 9.36154 3.49449 9.09785 3.80186 8.9142C3.96852 8.81459 4.0229 8.59873 3.92329 8.43207C3.82368 8.26543 3.60794 8.21101 3.44116 8.31064C3.02445 8.55966 2.6832 8.91718 2.45385 9.34503C2.36217 9.51617 2.42655 9.72924 2.59771 9.82095Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_8608_27040'>
          <rect
            width='12'
            height='12'
            fill={color}
            transform='translate(0 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export function CarIcon({ color = '#98A2B3' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='13'
      viewBox='0 0 12 13'
      fill='none'
    >
      <path
        d='M7.755 1.91504H4.245C3 1.91504 2.725 2.53504 2.565 3.29504L2 6.00004H10L9.435 3.29504C9.275 2.53504 9 1.91504 7.755 1.91504Z'
        stroke={color}
        strokeWidth='0.7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.9944 10.41C11.0494 10.995 10.5794 11.5 9.97938 11.5H9.03938C8.49938 11.5 8.42438 11.27 8.32938 10.985L8.22938 10.685C8.08938 10.275 7.99938 10 7.27938 10H4.71938C3.99938 10 3.89438 10.31 3.76938 10.685L3.66938 10.985C3.57438 11.27 3.49938 11.5 2.95938 11.5H2.01938C1.41938 11.5 0.94938 10.995 1.00438 10.41L1.28438 7.365C1.35438 6.615 1.49938 6 2.80938 6H9.18938C10.4994 6 10.6444 6.615 10.7144 7.365L10.9944 10.41Z'
        stroke={color}
        strokeWidth='0.7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2 4.5H1.5'
        stroke={color}
        strokeWidth='0.7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.5 4.5H10'
        stroke={color}
        strokeWidth='0.7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6 2V3'
        stroke={color}
        strokeWidth='0.7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.25 3H6.75'
        stroke={color}
        strokeWidth='0.7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3 8H4.5'
        stroke={color}
        strokeWidth='0.7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.5 8H9'
        stroke={color}
        strokeWidth='0.7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function GlobalIcon({ color = '#98A2B3' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='10'
      height='13'
      viewBox='0 0 10 13'
      fill="none"
    >
      <path
        d='M7.95662 12.5H0.673828V2.02923H7.95662C8.71202 2.02923 9.32439 2.6416 9.32439 3.39698V11.1323C9.32439 11.8876 8.71202 12.5 7.95662 12.5Z'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.673828 2.0293L6.37877 0.551657C7.28405 0.28482 8.19323 1.09504 8.07746 2.0293'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.77993 6.70375C7.77993 8.23997 6.5346 9.48535 4.99835 9.48535C3.46213 9.48535 2.2168 8.23997 2.2168 6.70375C2.2168 5.16753 3.46213 3.92217 4.99835 3.92217C6.5346 3.92217 7.77993 5.16753 7.77993 6.70375Z'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.7619 3.94458C3.72943 5.99909 3.72139 7.41603 4.74524 9.4624'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.24856 9.4624C6.27339 7.41262 6.27376 5.99571 5.24219 3.94458'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.30078 6.70361H7.69402'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.32031 11.0039H3.61163'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.10742 11.0039H7.78073'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function FileIcon({ color = '#98A2B3' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='13'
      viewBox='0 0 12 13'
      fill="none"
    >
      <path
        d='M10.9646 3.88L9.27958 10.645C9.15958 11.15 8.70958 11.5 8.18958 11.5H1.61958C0.864576 11.5 0.324584 10.76 0.549584 10.035L2.65458 3.27502C2.79958 2.80502 3.23459 2.47998 3.72459 2.47998H9.87458C10.3496 2.47998 10.7446 2.76998 10.9096 3.16998C11.0046 3.38498 11.0246 3.63 10.9646 3.88Z'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
      />
      <path
        d='M8 11.5H10.39C11.035 11.5 11.54 10.955 11.495 10.31L11 3.5'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.83984 3.69025L5.35985 1.53027'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.18945 3.69489L8.65945 1.5249'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.84961 6.5H7.84961'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.34961 8.5H7.34961'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function MasgedIcon({ color = '#98A2B3' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='13'
      viewBox='0 0 12 13'
      fill='none'
    >
      <path
        d='M0.351562 8.70887H11.6482M0.351562 12.148H11.6482M10.5701 8.70887V6.80728H1.42965V8.70887M9.04672 8.70887V6.80728M7.5233 8.70887V6.80728M5.9999 8.70887V6.80728M4.47647 8.70887V6.80728M2.95307 8.70887V6.80728M9.75001 6.80728C9.75001 4.74611 8.07911 3.0752 6.01793 3.0752H5.98182C3.92066 3.0752 2.24974 4.74609 2.24974 6.80728M1.11306 8.70887H10.9423V12.148H1.11306V8.70887Z'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.02823 0.852051V1.954M7.17639 3.25974V3.13196C7.17639 2.48248 6.64988 1.95599 6.00043 1.95599C5.35095 1.95599 4.82446 2.4825 4.82446 3.13196V3.25974M3.19762 9.96449C2.77457 9.96449 2.43164 10.3074 2.43164 10.7305V12.1483H3.9636V10.7305C3.9636 10.3074 3.62064 9.96449 3.19762 9.96449ZM6.00043 9.96449C5.57738 9.96449 5.23445 10.3074 5.23445 10.7305V12.1483H6.76641V10.7305C6.76641 10.3074 6.42345 9.96449 6.00043 9.96449ZM8.80324 9.96449C8.38019 9.96449 8.03726 10.3074 8.03726 10.7305V12.1483H9.56922V10.7305C9.56922 10.3074 9.22626 9.96449 8.80324 9.96449Z'
        stroke={color}
        strokeWidth='0.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}


export function WalletIcon({ color = "#98A2B3" }) {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.5 12V17C22.5 20 20.5 22 17.5 22H7.5C4.5 22 2.5 20 2.5 17V12C2.5 9.28 4.14 7.38 6.69 7.06C6.95 7.02 7.22 7 7.5 7H17.5C17.76 7 18.01 7.00999 18.25 7.04999C20.83 7.34999 22.5 9.26 22.5 12Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.2514 7.05C18.0114 7.01 17.7614 7.00001 17.5014 7.00001H7.50141C7.22141 7.00001 6.95141 7.02001 6.69141 7.06001C6.83141 6.78001 7.03141 6.52001 7.27141 6.28001L10.5214 3.02C11.8914 1.66 14.1114 1.66 15.4814 3.02L17.2314 4.79002C17.8714 5.42002 18.2114 6.22 18.2514 7.05Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22.5 12.5H19.5C18.4 12.5 17.5 13.4 17.5 14.5C17.5 15.6 18.4 16.5 19.5 16.5H22.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
export function AlertCircleIcon({ color = "#98A2B3" }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path id="Icon" d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
export function VisaCardIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="73.679" height="34.768">
    <g id="Group_4069" data-name="Group 4069" transform="translate(-0.001 0)">
      <g id="visa_logo_icon_206647" transform="translate(38.911 0)">
        <path id="Path_556" data-name="Path 556" d="M0,0H34.768V34.768H0Z" fill="none" />
        <path id="Path_557" data-name="Path 557" d="M32.193,19.2l-.326-1.63H28.225l-.579,1.618-2.919.006Q26.811,14.179,28.9,9.171a1.277,1.277,0,0,1,1.28-.851q.713.007,2.327,0L34.768,19.2l-2.576,0Zm-3.148-3.862h2.347l-.876-4.085ZM10.228,8.318l2.935,0L8.625,19.2l-2.971,0Q4.534,14.887,3.441,10.57A1.491,1.491,0,0,0,2.457,9.4Q1.72,9.151,0,8.62v-.3H4.689a1.316,1.316,0,0,1,1.437,1.2q.23,1.21,1.159,6.163Zm6.968,0L14.875,19.2l-2.793,0L14.4,8.318Zm5.664-.2a7.748,7.748,0,0,1,2.495.5l-.49,2.256a6.326,6.326,0,0,0-2.206-.507c-1.1.019-1.782.481-1.782.924,0,.721,1.182,1.085,2.4,1.873a2.687,2.687,0,0,1,1.554,2.582c-.019,1.82-1.554,3.614-4.794,3.614a8.024,8.024,0,0,1-3.216-.574l.51-2.354a6.078,6.078,0,0,0,2.8.678c.96,0,1.785-.388,1.792-1.065.006-.481-.29-.72-1.368-1.314s-2.59-1.42-2.57-3.074c.025-2.118,2.031-3.539,4.881-3.539Z" transform="translate(0 3.643)" fill="#d29d4d" />
      </g>
      <path id="Icon_payment-mastercard-alt" data-name="Icon payment-mastercard-alt" d="M42.424,27.522a11.17,11.17,0,0,0-1.478-5.632,12.83,12.83,0,0,0-4.063-4.063,11.861,11.861,0,0,0-5.632-1.477,10.656,10.656,0,0,0-6.741,2.308,11.228,11.228,0,0,1,3.509,5.817H27a10.635,10.635,0,0,0-3.232-5.263,10.624,10.624,0,0,0-3.232,5.263H19.524a11.22,11.22,0,0,1,3.509-5.817,10.663,10.663,0,0,0-6.741-2.308,11.855,11.855,0,0,0-5.632,1.477A12.812,12.812,0,0,0,6.6,21.89a11.474,11.474,0,0,0,0,11.264,12.8,12.8,0,0,0,4.063,4.063,11.841,11.841,0,0,0,5.632,1.477,10.657,10.657,0,0,0,6.741-2.308,11.637,11.637,0,0,1-3.417-5.355h1.016a11.237,11.237,0,0,0,3.139,4.8,11.253,11.253,0,0,0,3.139-4.8h1.016a11.665,11.665,0,0,1-3.417,5.355,10.648,10.648,0,0,0,6.741,2.308,11.844,11.844,0,0,0,5.632-1.477,12.817,12.817,0,0,0,4.063-4.063,11.172,11.172,0,0,0,1.477-5.632Zm-32.41-2.678h1.755L10.845,30.2H9.737l.646-4.063L8.906,30.2H8.075V26.137L7.336,30.2H6.228l.923-5.355H8.814v3.324Zm5.171,2.216a4.379,4.379,0,0,1-.093.831c-.062.431-.125.831-.185,1.2a6.183,6.183,0,0,1-.185.831V30.2H13.8v-.462a1.337,1.337,0,0,1-1.2.554,1,1,0,0,1-.739-.277,1.5,1.5,0,0,1-.277-.923,1.444,1.444,0,0,1,.462-1.2,2.628,2.628,0,0,1,1.57-.462h.462v-.278c0-.245-.247-.369-.739-.369a5.187,5.187,0,0,0-1.2.185c.06-.245.123-.554.185-.923a3.763,3.763,0,0,1,1.293-.277q1.57,0,1.57,1.293Zm-1.292,1.2h-.277c-.616,0-.923.217-.923.646,0,.309.123.462.369.462a.625.625,0,0,0,.554-.277A1.129,1.129,0,0,0,13.892,28.261Zm4.524-2.4-.185,1.016a2.842,2.842,0,0,0-.831-.092c-.37,0-.554.124-.554.369a.371.371,0,0,0,.093.277l.369.185a1.367,1.367,0,0,1,.831,1.2q0,1.478-1.755,1.477a5.454,5.454,0,0,1-1.2-.093c.06-.245.123-.585.185-1.016a5,5,0,0,0,1.016.185c.429,0,.646-.123.646-.369a.383.383,0,0,0-.093-.277,1.18,1.18,0,0,0-.462-.277,1.243,1.243,0,0,1-.831-1.2q0-1.475,1.662-1.477a4.3,4.3,0,0,1,1.109.093Zm1.754,0h.554l-.093,1.108h-.646a3.485,3.485,0,0,1-.093.831,2.885,2.885,0,0,1-.046.369.728.728,0,0,1-.139.369v.369a.326.326,0,0,0,.369.369.816.816,0,0,0,.369-.093L20.263,30.2a2.8,2.8,0,0,1-.831.093.816.816,0,0,1-.923-.923,4.33,4.33,0,0,1,.185-1.2l.462-2.955h1.108l-.092.647Zm4.155,1.477a5.824,5.824,0,0,1-.093,1.108H21.925a.891.891,0,0,0,.185.646,1.129,1.129,0,0,0,.831.277,2.447,2.447,0,0,0,1.2-.369l-.185,1.108a3.262,3.262,0,0,1-1.2.185,1.714,1.714,0,0,1-1.939-1.939,2.759,2.759,0,0,1,.554-1.847,1.672,1.672,0,0,1,1.385-.739,1.628,1.628,0,0,1,1.2.462,1.514,1.514,0,0,1,.369,1.108Zm-2.309.185H23.31v-.277l-.093-.185a.274.274,0,0,0-.093-.185.261.261,0,0,1-.185-.092h-.185q-.554,0-.739.739Zm5.171-1.662a6.879,6.879,0,0,0-.462,1.293c-.247-.06-.462.092-.646.462a18.176,18.176,0,0,0-.462,2.585h-1.2l.093-.277q.367-2.583.554-4.063h1.108l-.093.646a1.18,1.18,0,0,1,.554-.554.4.4,0,0,1,.554-.092Zm3.878-.831-.185,1.108a2.3,2.3,0,0,0-1.016-.277,1.239,1.239,0,0,0-1.108.554,2.366,2.366,0,0,0-.369,1.477,1.273,1.273,0,0,0,.277.923.874.874,0,0,0,.739.369,2.3,2.3,0,0,0,1.016-.277l-.185,1.2a2.294,2.294,0,0,1-1.016.185,1.847,1.847,0,0,1-1.477-.646,2.258,2.258,0,0,1-.554-1.662,3.57,3.57,0,0,1,.739-2.308,2.119,2.119,0,0,1,1.847-.923,4.446,4.446,0,0,1,1.292.277ZM34.39,27.06a2.9,2.9,0,0,1-.046.369,2.745,2.745,0,0,0-.046.462c-.062.309-.125.724-.185,1.246a6.524,6.524,0,0,1-.185,1.062h-.923v-.462a1.337,1.337,0,0,1-1.2.554,1,1,0,0,1-.739-.277,1.5,1.5,0,0,1-.277-.923,1.444,1.444,0,0,1,.462-1.2,2.477,2.477,0,0,1,1.477-.462h.462a.38.38,0,0,0,.093-.277c0-.245-.247-.369-.739-.369a5.187,5.187,0,0,0-1.2.185,2.993,2.993,0,0,1,.185-.923,3.763,3.763,0,0,1,1.293-.277q1.569,0,1.569,1.293Zm-1.292,1.2h-.277c-.616,0-.923.217-.923.646,0,.309.123.462.369.462a.625.625,0,0,0,.554-.277A1.129,1.129,0,0,0,33.1,28.261Zm4.155-2.4a2.459,2.459,0,0,0-.462,1.293c-.247-.06-.462.092-.646.462a18.605,18.605,0,0,0-.462,2.585h-1.2l.093-.277q.366-2.018.554-4.063h1.108a2.078,2.078,0,0,1-.093.646,1.18,1.18,0,0,1,.554-.554.66.66,0,0,1,.554-.092Zm2.862-1.016h1.2L40.392,30.2H39.284l.093-.369a1.229,1.229,0,0,1-1.016.462,1.082,1.082,0,0,1-1.016-.462,2.2,2.2,0,0,1-.462-1.293A2.84,2.84,0,0,1,37.53,26.6a1.448,1.448,0,0,1,1.293-.739,1.6,1.6,0,0,1,1.108.554l.185-1.57Zm-.462,2.862c0-.554-.217-.831-.646-.831a.779.779,0,0,0-.646.462,1.952,1.952,0,0,0-.185,1.016q0,.831.554.831a.8.8,0,0,0,.646-.369,1.834,1.834,0,0,0,.277-1.108Z" transform="translate(-5.119 -10.139)" fill="#d29d4d" />
    </g>
  </svg>
}
export function DueAmountIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
    <path d="M58.667 16.0002V22.4535C58.667 26.6668 56.0003 29.3335 51.7869 29.3335H42.667V10.6935C42.667 7.7335 45.0937 5.3335 48.0537 5.3335C50.9604 5.36016 53.627 6.5335 55.547 8.4535C57.467 10.4002 58.667 13.0668 58.667 16.0002Z" stroke="#D2AB67" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.33301 18.6668V56.0002C5.33301 58.2135 7.83961 59.4668 9.59961 58.1335L14.1597 54.7202C15.2263 53.9202 16.7197 54.0268 17.6797 54.9868L22.1063 59.4402C23.1463 60.4802 24.8531 60.4802 25.8931 59.4402L30.373 54.9602C31.3064 54.0268 32.7997 53.9202 33.8397 54.7202L38.3997 58.1335C40.1597 59.4402 42.6663 58.1868 42.6663 56.0002V10.6668C42.6663 7.7335 45.0663 5.3335 47.9997 5.3335H18.6663H15.9997C7.99967 5.3335 5.33301 10.1068 5.33301 16.0002V18.6668Z" stroke="#D2AB67" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 24H32" stroke="#D2AB67" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 34.6665H30" stroke="#D2AB67" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
}
export function CalenderIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path d="M8.33398 2V5" stroke="#1E85FF" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.334 2V5" stroke="#1E85FF" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.83398 9.08984H20.834" stroke="#1E85FF" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21.334 8.5V17C21.334 20 19.834 22 16.334 22H8.33398C4.83398 22 3.33398 20 3.33398 17V8.5C3.33398 5.5 4.83398 3.5 8.33398 3.5H16.334C19.834 3.5 21.334 5.5 21.334 8.5Z" stroke="#1E85FF" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.3295 13.7002H12.3385" stroke="#1E85FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.6283 13.7002H8.63728" stroke="#1E85FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.6283 16.7002H8.63728" stroke="#1E85FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
}
export function CurrencyHeaderIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 26 27" fill="none">
    <path d="M9.39453 16.0237C9.39453 17.4212 10.467 18.5478 11.7995 18.5478H14.5187C15.6779 18.5478 16.6204 17.562 16.6204 16.3487C16.6204 15.027 16.0462 14.5612 15.1904 14.2578L10.8245 12.7412C9.9687 12.4378 9.39453 11.972 9.39453 10.6503C9.39453 9.437 10.337 8.45117 11.4962 8.45117H14.2154C15.5479 8.45117 16.6204 9.57784 16.6204 10.9753" stroke="#222222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 7V20" stroke="#222222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.9993 24.3337C18.9824 24.3337 23.8327 19.4834 23.8327 13.5003C23.8327 7.51724 18.9824 2.66699 12.9993 2.66699C7.01626 2.66699 2.16602 7.51724 2.16602 13.5003C2.16602 19.4834 7.01626 24.3337 12.9993 24.3337Z" stroke="#222222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
}

export function CalenderSm() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8 2V5"
        stroke="#707170"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 2V5"
        stroke="#707170"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 9.08984H20.5"
        stroke="#707170"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
        stroke="#707170"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6947 13.7002H15.7037"
        stroke="#707170"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6947 16.7002H15.7037"
        stroke="#707170"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9955 13.7002H12.0045"
        stroke="#707170"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9955 16.7002H12.0045"
        stroke="#707170"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.29431 13.7002H8.30329"
        stroke="#707170"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.29431 16.7002H8.30329"
        stroke="#707170"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LocationIcon({ width }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || "11.156"} height={width || "13.413"} viewBox="0 0 11.156 13.413">
      <g id="Group_3769" data-name="Group 3769" transform="translate(0.5 0.5)">
        <path id="Path_3382" data-name="Path 3382" d="M10.156,5.078c0,3.949-5.078,7.335-5.078,7.335S0,9.027,0,5.078a5.078,5.078,0,1,1,10.156,0Z" fill="none" stroke="#616a71" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" fillRule="evenodd" />
        <circle id="Ellipse_44" data-name="Ellipse 44" cx="1.754" cy="1.754" r="1.754" transform="translate(3.508 3.643)" fill="none" stroke="#616a71" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" />
      </g>
    </svg>
  )
}

export function GalleryremoveIcon({ color = "#707170" }) {
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 16L16 8M16 16L8 8" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>

}